// @ts-nocheck
/* eslint-disable */

import React from 'react';
import EditEntity from '../../components/CRUD/EditEntity';

const UpdatePassengersGroup = () => {
  return (
    <EditEntity
      pageTitle="EditPassengersGroup"
      fetchApiUrl="/api/v1/web_portal/fare_media_policy_capping/passengers_groups/:id"
      fetchApiMethod="GET"
      dataPath="data.data" // updated to reflect backend change
      inputs={[
        {
          name: 'name',
          labelKey: 'ArName',
          inputType: 'text',
          required: true,
        },
        {
          name: 'en_name',
          labelKey: 'EnName',
          inputType: 'text',
          required: true,
        },
        {
          name: 'description',
          labelKey: 'description',
          inputType: 'text',
          required: false,
        },
        {
          name: 'is_default',
          labelKey: 'IsDefaultGroup',
          type: 'checkbox',
          required: false,
        }
      ]}
      dropdowns={[]}
      updateApiUrl="/api/v1/web_portal/fare_media_policy_capping/passengers_groups/:id"
      updateApiMethod="PATCH"
      successMessage="PassengersGroupUpdatedSuccessfully"
      successUrl="/fare-products/passengers-groups"
      backUrl="/fare-products/passengers-groups/:id"
      subsystemName="PassengersGroups"
      permissionSystem="fares"
    />
  );
};

export default UpdatePassengersGroup;
